import { render, staticRenderFns } from "./GerarCteAssociado.vue?vue&type=template&id=66be8a94"
import script from "./GerarCteAssociado.vue?vue&type=script&lang=js"
export * from "./GerarCteAssociado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports